<template>
  <div class="stored-value-recharge">
    <div class="accountMain" v-if="accountMainShow()">
      <div class="accountMainTitle">
        <div class="accountTitleBox">
          <div class="accountMainTitleName">充值金额</div>
          <template v-if="this.activityAlive">
            <div class="activityExtraImg">
              <img src="@/assets/img/activity/pay-extra.png" />
            </div>
            <el-popover placement="right-start" width="352" trigger="hover">
              <div class="hoverTextBox">
                <p>活动规则：</p>
                <div class="item">
                  <div class="id">①</div>
                  <div class="text">所有未付费的单体用户均可参与本次活动。</div>
                </div>
                <div class="item">
                  <div class="id">②</div>
                  <div class="text">赠送金额不可用作支付年费会员时的抵扣金额。</div>
                </div>
                <div class="item">
                  <div class="id">③</div>
                  <div class="text">
                    本次活动中，同一账号仅可在“充100赠100”和“充200赠200”两种模式中选择其中一种，请根据您的实际需求选择适合自己的活动哦！
                  </div>
                </div>
              </div>
              <el-button class="ruleText" type="text" slot="reference">活动规则</el-button>
            </el-popover>
          </template>
        </div>
        <div class="bili">当前兑换比例为1:{{ rechargeRatio }}，如支付100元可兑换{{ rechargeRatioNum }}点</div>
      </div>
      <div class="core">
        <div class="inputNum">
          <div class="numberAreaBefore">支付</div>
          <div class="numberArea">
            <el-input-number v-model="num" @change="numChange" :min="1" :step-strictly="true"></el-input-number>
          </div>
          <div class="numberAreaAdd">X 100 元 = {{ sum }} 元</div>
          <div class="payTip">
            <img class="bgtip" :src="require('@/assets/img/account/bg.png')" alt="" />
            <div class="tipText" v-show="showTip">
              可
              <span>购买{{ rechargeCoin }}</span>
              点数
              <em v-show="freeCoin != 0">
                +
                <span>赠送{{ freeCoin }}</span>
                点数 =
              </em>
              <span>总计{{ rechargeCoin + freeCoin }}点</span>
            </div>
          </div>
        </div>
        <div class="payType">
          <el-radio v-model="payType" label="1">
            <div class="rl">
              <img :src="require('@/assets/img/alipay.png')" alt="" />
              <span>支付宝支付</span>
            </div>
          </el-radio>
          <el-radio v-model="payType" label="2">
            <div class="rl">
              <img :src="require('@/assets/img/wepay.png')" alt="" />
              <span>微信支付</span>
            </div>
          </el-radio>
        </div>
        <div class="paySure">
          <div class="sure" @mousedown="getPayParams"><span>确认支付</span></div>
        </div>
      </div>
    </div>
    <div class="accountText" v-if="accountMainShow()">
      <div class="accountMainTitleName">充值金额</div>
      <div class="case">
        <ul>
          <li>1、充值赠送的点数，将无法在抵扣现金时使用；但赠送点数会保留在您的账号中</li>
          <li>2、当使用电子处方时，会优先消耗您非赠送的点数</li>
          <li>3、PC端账户充值仅限微信、支付宝充值，充值金额实时到账</li>
          <li>4、当发生退款时，仅支持退回账户中剩余的非赠送点数</li>
          <li>5、当您的钱包出现问题，或未即时到账时，请及时联系您的业务经理处理</li>
          <li>6、充值点数使用规则最终解释权归智云问诊所有</li>
        </ul>
      </div>
    </div>
    <div class="hint-wrapper" v-if="!userInfo.rechargeEntrance">
      <div class="content">
        <p class="title">门店账户在线充值功能下线通知</p>
        <p class="text">尊敬的各位合作伙伴：</p>
        <p class="text">您好！</p>
        <p class="text">
          因智云健康问诊产品服务升级，PC端
          <span class="highlight">「门店账户-充值金额」</span>
          功能已于
          <span class="highlight">2021年5月1日00:00:00</span>
          下线，不再对外开放使用，此次调整
          <span class="highlight">不影响您门店中的剩余点数及正常问诊开方</span>
          ，对此我们深表歉意，若您对本次升级调整有任何疑问，请及时致电您的销售经理。感谢您对智云问诊的使用和支持！
        </p>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="请扫码完成支付" class="accout_dialog">
      <div class="close" @click="canclePay()">
        <span>x</span>
      </div>
      <div class="dgbody">
        <div class="qrcode" ref="qr"></div>
      </div>
      <div class="dgfoot">
        <div class="btncancle" @click="canclePay()">取消支付</div>
        <div class="btnsure" @click="payDone">支付完成</div>
      </div>
    </el-dialog>
    <el-dialog width="378px" :visible.sync="waitDialogVisible" center class="waitDialog" :before-close="beforeClose">
      <div class="waitDialogHeader">
        <img :src="require('@/assets/img/account/clock.png')" alt="" />
        <span>倒计时{{ endTime }}S</span>
      </div>
      <div class="waitDialogContent">
        <span>正在同步信息倒计时...</span>
        <vue-loading type="cylon" color="#1E8DFF" :size="{ width: '50px', height: '50px' }"></vue-loading>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 这里只是针对储值和普通的支付，支付直接对接ping++，通过开关进行开启关闭，现在线上全部关闭状态，跟产品沟通确定业务可能随时都会打开，所以保留这部分代码，在上层再抽离了一层，后续要切到中台支付的话，可直接接入pc端中台支付交互

import { qrImg } from '@fastweb/f2e-utils';
import { VueLoading } from 'vue-loading-template';
import { mapGetters, mapActions, mapState } from 'vuex';

const logo = require('@/assets/img/wzlogo.png');
export default {
  data() {
    return {
      waitDialogVisible: false, // 等待弹窗
      orderId: null, // 订单ID
      dialogVisible: false, // 支付弹窗
      num: 1,
      payType: '1',
      rechargeCoin: 0, // 显示充值金额
      freeCoin: 0, // 显示赠送金额
      rechargeRatio: null, // 兑换比例
      endTime: 10, // 倒计时
      showTip: false
    };
  },
  components: { VueLoading },
  computed: {
    ...mapState('global', ['userInfo']),
    ...mapGetters(['storeAccoutnInfo', 'activityId', 'activityAlive']),
    sum() {
      return this.num * 100;
    },
    rechargeRatioNum() {
      return Math.round(100 * this.rechargeRatio);
    }
  },
  created() {
    if (this.accountMainShow()) {
      this._recharge_money_calculate();
    }
  },
  methods: {
    accountMainShow() {
      const { isExpire } = this.storeAccoutnInfo;
      const { rechargeEntrance } = this.userInfo;
      return !isExpire && rechargeEntrance;
    },
    beforeClose(done) {
      clearTimeout(this.lastEndTimer);
      done();
    },
    startEndTime() {
      // 付款后倒数计时
      this.endTime--;
      if (this.endTime == 0) {
        this.waitDialogVisible = false;
        this.endTime = 10;
        this.$message.error('查询订单超时');
        clearTimeout(this.timer);
        return;
      }
      this.lastEndTimer = setTimeout(() => {
        this.startEndTime();
      }, 1000);
    },
    async payDone() {
      // 支付完成

      this.dialogVisible = false;
      this.get_recharge_order(); // 轮训订单状态
      this.waitDialogVisible = true;
      this.startEndTime(); // 倒计时
    },
    async get_recharge_order() {
      // 查询订单状态
      this.timer = setTimeout(() => {
        this.get_recharge_order();
      }, 2000);
      const { orderId } = this;
      let res = await Fetch.get_recharge_order({ orderId });
      if (res.status == 1) {
        // 支付成功
        location.reload();
      }
    },
    canclePay() {
      // 取消支付
      this.dialogVisible = false;
    },
    async _recharge_money_calculate() {
      let params = { price: 10000 };
      this.activityAlive && (params.activityId = this.activityId);
      let res = await Fetch.recharge_money_calculate(params);
      this.rechargeRatio = res.rechargeRatio; // 获取兑换比例
      this.rechargeCoin = res.rechargeCoin; // 充值
      this.freeCoin = res.freeCoin; // 赠送
      this.showTip = true;
    },
    async reCalculate() {
      // 数字改变后重新计算金额
      let ct = this.moneyChange(this.num);
      let params = { price: ct };
      this.activityAlive && (params.activityId = this.activityId);
      let res = await Fetch.recharge_money_calculate(params);
      this.rechargeRatio = res.rechargeRatio; // 刷新兑换比例
      this.rechargeCoin = res.rechargeCoin;
      this.freeCoin = res.freeCoin;
    },
    numChange() {
      // 金额改变后重新获取
      if (!this.num) {
        setTimeout(() => {
          // 修复用户把数字删了的问题
          this.num = 1;
          this.reCalculate();
        }, 0);
        return;
      }
      // 解决用户输入小数点 后端 校验问题
      this.num = parseInt(this.num);
      this.reCalculate();
    },
    payAfter(err, url) {
      if (err) {
        console.log(err);
      }
      window.open = `${url}`;
    },
    getPayParams() {
      // 获取支付参数

      const _this = this;
      Util.submitOnce(function () {
        _this.pay();
      });
    },
    async pay() {
      // 支付
      const { storeAccoutnInfo } = this;
      if (storeAccoutnInfo.storeType == 1) {
        // 年费
        this.$message.error('年费用户不可充值');
        return;
      }

      if (storeAccoutnInfo.storeType == 3) {
        // 试用
        this.$message.error('试用用户不可充值');
        return;
      }
      let ct = this.moneyChange(this.num);
      const { payType } = this;
      console.log(ct, '分');
      const params = {
        price: ct,
        // payWay: payType * 3,
        // payWay: 5,
        payWay: payType * 1,
        rechargeValue: Math.round((ct / 100) * this.rechargeRatio) // 计算总点数
      };
      this.activityAlive && (params.activityId = this.activityId);
      if (this.qr) {
        this.qr.clear();
      }
      let res;
      try {
        res = await Fetch.recharge_order(params);
      } catch (err) {
        if (err.code === 'INVALID_PARAM') this.$store.commit('activity/SET_ACTIVITY_STATUS', 0);
        return;
      }
      let { payString, orderId } = res;
      this.orderId = orderId;
      this.dialogVisible = true;
      const _this = this;
      this.$nextTick(() => {
        _this.qr = qrImg(_this.$refs.qr, {
          text: payString,
          width: 200,
          height: 200,
          logoWidth: 50,
          logoHeight: 50,
          logoBackgroundTransparent: true,
          colorDark: '#1E8DFF',
          logo: logo
        });
      });
    },
    moneyChange(y) {
      // 元换分
      let tr = y * 100 * 10 * 10; // 元转分
      return tr;
    }
  }
};
</script>

<style lang="scss">
.waitDialog {
  .waitDialogHeader {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 15px;
    img {
      display: block;
      width: 16px;
      margin-right: 16px;
    }
    span {
      display: block;
      color: #242424;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .waitDialogContent {
    padding-bottom: 26px;
    text-align: center;
    span {
      color: #242424;
      font-size: 14px;
    }
  }
}
.accout_dialog {
  .close {
  }
  .el-dialog__header {
    text-align: center;
  }
  .dgbody {
    padding-bottom: 16px;
    .qrcode {
      width: 200px;
      margin: 0 auto;
    }
  }
  .dgfoot {
    display: flex;
    justify-content: center;
    .basebtn {
      cursor: pointer;
      width: 132px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btncancle {
      @extend .basebtn;
      border-radius: 4px;
      border: 1px solid #1e8dff;
      color: #1e8dff;
      margin-right: 20px;
    }
    .btnsure {
      margin-left: 20px;
      background: #1e8dff;
      border-radius: 4px;
      border: 1px solid #1e8dff;
      color: #fff;
      @extend .basebtn;
    }
  }
}
.hoverTextBox {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: rgba(112, 112, 112, 1);
  .item {
    display: flex;
    width: 100%;
    margin-top: 4px;
  }
  .id {
    width: 6%;
  }
  .text {
    width: 90%;
  }
}
</style>
<style lang="scss" scoped>
.stored-value-recharge {
  .accountMain {
    padding: 16px;

    box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
    border-radius: 4px;
    border: 1px solid rgba(242, 242, 242, 1);
    background: #fff;
    margin-bottom: 16px;
    .accountMainTitle {
      .accountMainTitleName {
        height: 100%;
        line-height: 100%;
        font-size: 14px;
        color: #242424;
        font-weight: bold;
      }
      .bili {
        font-size: 14px;
        margin-top: 8px;
        color: #707070;
      }
    }
    .accountTitleBox {
      display: flex;
      align-items: center;
    }
    .activityExtraImg {
      // display: inline-block;
      margin-left: 10px;
      width: 245px;
      img {
        width: 100%;
      }
    }
    .ruleText {
      height: 100%;
      line-height: 100%;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: rgba(211, 161, 117, 1);
      text-decoration: underline;
    }
    .core {
      padding-top: 22px;
      .inputNum {
        display: flex;
        align-items: center;
        position: relative;
        .numberAreaBefore {
          font-weight: bold;
          font-size: 14px;
          color: #242424;
        }
        .numberArea {
          padding: 0 13px;
        }
        .numberAreaAdd {
          font-weight: bold;
          font-size: 14px;
          color: #242424;
        }
        .payTip {
          position: absolute;
          top: 50px;
          width: 100%;
          height: 40px;
          .bgtip {
            position: absolute;
            top: -10px;
            width: 370px;
          }
          .tipText {
            position: absolute;
            z-index: 3;
            width: 100%;
            color: #fff;
            padding-left: 16px;
            top: 5px;
            span {
              font-weight: bold;
            }
          }
        }
      }
      .payType {
        margin-top: 64px;
        display: flex;

        .el-radio {
          display: flex;
          align-items: center;
          .rl {
            display: flex;
            align-items: center;
            img {
              width: 22px;
              margin-right: 12px;
            }
            span {
              color: #242424;
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
      }
      .paySure {
        margin-top: 28px;
        .sure {
          background: #1e8dff;
          width: 132px;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #1e8dff;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          span {
            font-size: 14px;
            color: #fff;
          }
        }
      }
    }
  }
  .accountText {
    padding: 16px;
    box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
    border-radius: 4px;
    border: 1px solid rgba(242, 242, 242, 1);
    background: #fff;
    .accountMainTitleName {
      font-size: 14px;
      color: #242424;
      font-weight: bold;
    }
    .case {
      padding-top: 12px;
      ul {
        li {
          color: #707070;
          font-size: 14px;
        }
      }
    }
  }
}
.hint-wrapper {
  position: relative;
  width: 100%;
  height: 484px;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 8px;
  border: 1px solid #f2f2f2;
  background: #fff url('~@/assets/img/accountBg.png') no-repeat center center;
  background-size: 470px 396px;
  box-sizing: border-box;

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 25px 40px;
    width: 470px;
    height: 396px;
    transform: translate(-50%, -50%);

    .title {
      margin-bottom: 13px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #333;
    }

    .text {
      font-size: 14px;
      color: #707070;
      line-height: 24px;

      .highlight {
        color: #ff8200;
      }
    }
  }
}
</style>
